"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExistingControlTab = void 0;
var React = require("react");
var controls_1 = require("../../interfaces/controls");
var mobx_react_1 = require("mobx-react");
var App_1 = require("../../App");
var api_1 = require("../../api");
var buttons_1 = require("../buttons");
var multiSelect_1 = require("../lib/multiSelect");
var ExistingControlTab = (function (_super) {
    __extends(ExistingControlTab, _super);
    function ExistingControlTab(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            searchTerm: "",
            statuses: controls_1.ControlStatusChoices.INCOMPLETE,
            results: [],
        };
        _this.handleSubmit();
        return _this;
    }
    ExistingControlTab.prototype.handleSearchTerm = function (event) {
        var target = event.target;
        var value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({
            searchTerm: value
        });
    };
    ExistingControlTab.prototype.handleStatusChange = function (value, checked) {
        var status = parseInt(value);
        var statuses = this.state.statuses;
        if (checked) {
            statuses.push(status);
        }
        else {
            statuses.splice(this.state.statuses.indexOf(status), 1);
        }
        this.setState({
            statuses: statuses
        });
    };
    ExistingControlTab.prototype.onCheckAllStatuses = function () {
        this.setState({
            statuses: controls_1.ControlStatusChoices.toList()
        });
    };
    ExistingControlTab.prototype.onUncheckAllStatuses = function () {
        this.setState({
            statuses: []
        });
    };
    ExistingControlTab.prototype.handleSubmit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var context, results;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        context = App_1.store.context.get();
                        results = [];
                        if (!context.risk) return [3, 2];
                        return [4, api_1.api.projects.id(context.project).risks.id(context.risk).attachable_controls.getAll({
                                status: this.state.statuses,
                                q: this.state.searchTerm,
                                page_size: 99999,
                            }).then(function (page) { return results = $.merge(results, page.results); })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.setState({
                            results: results
                        });
                        return [2];
                }
            });
        });
    };
    ExistingControlTab.prototype.render = function () {
        return React.createElement("div", null,
            React.createElement("div", { className: "ExistingControlTab" },
                React.createElement("div", { className: "form-group row" },
                    React.createElement("div", { className: "col-4" },
                        React.createElement("label", null,
                            gettext("Text"),
                            ":")),
                    React.createElement("div", { className: "col-8" },
                        React.createElement("input", { type: "text", name: "search", className: "form-control Element--fullwidth", placeholder: gettext("Search"), value: this.state.searchTerm, onChange: this.handleSearchTerm.bind(this) }))),
                React.createElement("div", { className: "form-group row" },
                    React.createElement("div", { className: "col-4" },
                        React.createElement("label", null,
                            gettext("Status"),
                            ":")),
                    React.createElement("div", { className: "col-8" },
                        React.createElement(multiSelect_1.Multiselect, { name: "status", choices: controls_1.ControlStatusChoices.asChoices(), value: this.state.statuses.map(function (s) { return s.toString(); }), onSingleChange: this.handleStatusChange.bind(this), onCheckAll: this.onCheckAllStatuses.bind(this), onUncheckAll: this.onUncheckAllStatuses.bind(this), selectedText: gettext('status(es) selected'), noneSelectedText: gettext("Select statuses"), classes: "MultiSelect__Button gm--fullwidth" }))),
                React.createElement("div", { className: "form-group row" },
                    React.createElement("div", { className: "col-8 offset-4" },
                        React.createElement(buttons_1.PrimaryButton, { onClick: this.handleSubmit.bind(this), noHMargin: true }, gettext("Search"))))),
            React.createElement("div", { className: "ExistingControlTab__Result" },
                React.createElement("ul", { className: "list-unstyled" }, this.state.results.map(function (control) {
                    return React.createElement("li", { key: control.id, onClick: function () { return App_1.store.controlDialog.openDialogForAttachment(control); } },
                        control.control_number,
                        " - ",
                        control.description);
                }))));
    };
    ExistingControlTab = __decorate([
        mobx_react_1.observer
    ], ExistingControlTab);
    return ExistingControlTab;
}(React.Component));
exports.ExistingControlTab = ExistingControlTab;
